// =====================================================================
// confirmLogic — the framework-free core of ConfirmContext, extracted so
// it can be unit-tested with Node's built-in runner (this repo has no JSX
// test runner; see pages/data/__tests__/dataBrowserLogic.test.mjs for the
// same precedent). ConfirmContext.jsx imports these; the .jsx only wires
// React state + the promise resolver around them.
// =====================================================================

// Default state for a closed dialog.
export const CLOSED_CONFIRM = {
  open: false,
  title: 'Are you sure?',
  message: '',
  confirmText: 'Confirm',
  isDangerous: false,
}

// Normalize the argument passed to confirm() into a full open-state object.
// Accepts either a plain string (message only) or an options object; missing
// fields fall back to sensible defaults. Anything not a string/object (null,
// number, undefined) is treated as an empty options object so a stray call
// can never throw at the call site.
export function normalizeConfirmOptions(opts) {
  const cfg = typeof opts === 'string'
    ? { message: opts }
    : (opts && typeof opts === 'object' ? opts : {})
  return {
    open: true,
    title: cfg.title ?? 'Are you sure?',
    message: cfg.message ?? '',
    confirmText: cfg.confirmText ?? 'Confirm',
    isDangerous: cfg.isDangerous ?? false,
  }
}
